export default {
  fi: {
    HomeCardReminder: {
      title: 'Viimeisimmät muistutukset',
      goToVehicle: 'Avaa ajoneuvon sivu',
    },
  },
};
